
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/navigation/documents",
      function () {
        return require("private-next-pages/navigation/documents/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/navigation/documents"])
      });
    }
  